var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgH1 = function SvgH1(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 13,
    viewBox: "0 0 20 13"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#007faf",
    fillRule: "evenodd",
    d: "M10.758 11V1.662H7.93v3.304H4.584V1.662H1.756V11h2.828V7.43H7.93V11zm6.762 0V1.662h-2.436l-3.57 3.5 1.596 1.666 1.582-1.568V11z"
  })));
};
export default SvgH1;